// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J1ZA3iKA0Owx5P9Igw8P{border-bottom:1px solid #ddd}`, "",{"version":3,"sources":["webpack://./src/components/tables/DefaultCostBreakdownTable/components/MobileCostBreakdown/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,4BAAA","sourcesContent":[".row\n  border-bottom: 1px solid #ddd\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `J1ZA3iKA0Owx5P9Igw8P`
};
export default ___CSS_LOADER_EXPORT___;
